module.exports = __webpack_public_path__ + "static/media/bag.e8fec5b3.png";